import React, { useState, useEffect } from "react";
import Cta from "../components/Cta";
import Faq from "../components/Faq";
import faqImage from "../assets/images/faq_img.webp";
import CustomAd from "../components/CustomAd";
import BenifitApp from "../components/BenifitApp";
import slide1 from "../assets/images/slide1.png";
import img1 from "../assets/images/img1.png";
import img2 from "../assets/images/img2.png";
import img3 from "../assets/images/img3.png";
import img4 from "../assets/images/img4.png";
import { Link } from "react-router-dom";
import Rightarrow from "../assets/icons/Rightarrow";
import rest1 from "../assets/images/rest1.webp";
import rest2 from "../assets/images/rest2.webp";
import rest3 from "../assets/images/rest3.webp";
import rest4 from "../assets/images/rest4.webp";
import Search from "../assets/icons/Search";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Location from "../assets/icons/Location";
import { Navigation, Autoplay } from "swiper/modules";
import ClientTestimonial from "../components/ClientTestimonial";
import Pricing from "../components/Pricing";
import RestaurantListCard from "../components/RestaurantListCard";
import { get, post, postWithImage } from "../network/api";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";


const Home = () => {
  const [query, setQuery] = useState("");

  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // for categires
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [errorCategories, setErrorCategories] = useState(null);
  const [lat, setLat] = useState(null);
  const [long, setLong] = useState(null);
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const navigate = useNavigate();

  const { t } = useTranslation();
let faqs = [
  { question: t("how_do_i_place_an_order_on_loadinn"), answer: t("to_place_an_order_log_in_select_restaurant_choose_items_checkout") },
  { question: t("can_i_order_from_multiple_restaurants_at_the_same_time"), answer: t("no_orders_must_be_placed_separately_for_each_restaurant") },
  { question: t("can_i_schedule_an_order_for_later"), answer: t("yes_you_can_schedule_an_order_for_a_later_time") },
  { question: t("what_payment_methods_are_accepted"), answer: t("we_accept_cards_apple_pay_google_pay_loadinn_wallet") },
  { question: t("are_there_any_hidden_charges"), answer: t("no_all_charges_are_displayed_before_confirming_the_order") },
  { question: t("can_i_add_a_tip_for_the_delivery_driver"), answer: t("yes_you_can_tip_the_driver_through_the_platform") },
  { question: t("how_can_i_track_my_order"), answer: t("you_can_track_your_order_via_website_or_tracking_email") },
  { question: t("can_i_contact_the_delivery_driver"), answer: t("yes_you_can_contact_the_driver_if_needed") },
  { question: t("what_if_my_delivery_is_delayed"), answer: t("we_try_to_deliver_as_soon_as_possible_contact_support_if_issue") },
  { question: t("can_i_cancel_my_order_after_placing_it"), answer: t("yes_but_cancellations_do_not_qualify_for_refund") },
  { question: t("under_what_conditions_can_i_get_a_refund"), answer: t("if_order_is_not_ready_after_one_hour_you_may_get_refund_contact_support_for_other_issues") },
  { question: t("how_long_does_refund_take"), answer: t("once_refund_is_approved_amount_is_credited_to_loadinn_wallet") },
  { question: t("do_i_need_an_account_to_place_an_order"), answer: t("yes_you_must_create_an_account_to_place_an_order") },
  { question: t("what_if_i_forget_my_password"), answer: t("you_can_reset_your_password_anytime_even_if_forgotten") },
  { question: t("how_can_i_contact_customer_support"), answer: t("you_can_contact_us_via_chat_support_on_our_website") },
];

  let benefits = [
    {
      title: t("fast_and_reliable_delivery"),
      description: t(
        "enjoy_quick_dependable_deliveries_with_realtime_tracking_to_keep_you_in_the_loop"
      ),
      image: img1,
    },
    {
      title: t("easy_to_order"),
      description: t(
        "explore_a_wide_variety_of_restaurants_and_cuisines_to_suit_every_taste_and_craving"
      ),
      image: img2,
    },
    {
      title: t("best_quality"),
      description: t(
        "savor_every_bite_with_confidence_knowing_our_meals_are_crafted_from_the_freshest_highest_quality_ingredients"
      ),
      image: img3,
    },
    {
      title: t("customer_support"),
      description: t(
        "experience_top_notch_support_and_service_ensuring_your_satisfaction_with_every_order"
      ),
      image: img4,
    },
  ];




  useEffect(() => {
    // Fetch data from API endpoint
    getRestaurants();
    getCategories();
  }, []);

  async function getRestaurants() {
    const now = new Date();
    setCurrentDate(now.toLocaleDateString());
    setCurrentTime(now.toLocaleTimeString());
    // Get current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLat(position.coords.latitude);
          setLong(position.coords.longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
    const requestData = {
      lat,
      long,
      date: currentDate,
      time: currentTime,
    };

    try {
      const data = await post("customer/restaurants", {
        lat: 12.9716,
        long: 77.5946,
        day: "Monday",
        time: "11:30",
      });
      console.log(data);
      setListings(data); // Store data in state
      setLoading(false);
    } catch (e) {
      // setError(error.message); // Handle any errors
      setLoading(false);
    }
  }
  async function getCategories() {
    try {
      const data = await post("customer/categories");
      console.log(data);
      setCategories(data); // Store data in state
      setLoading(false);
    } catch (e) {
      console.log(e);
      // setErrorCategories(error.message); // Handle any errors
      setLoadingCategories(false);
    }
  }
  const items = ["Apple", "Banana", "Cherry", "Date", "Elderberry"];

  console.log("Home in", process.env.REACT_APP_BASE_URL);

  return (
    <React.Fragment>
      <section className="hero_banner">
        <div className="wrapper">
          <div className="banner_content">
            <h1 className="usable_title">
              {t("satisfy_your_hunger_with")} <span>{t("just_a_tap")}</span>
            </h1>
            <p className="para_common">
              {t(
                "indulge_in_your_favorite_dishes_with_loadinn_where_every_delivery_feels_like_a_culinary_adventure"
              )}
            </p>
            <div className="cta_input custom_search_location">
              <div className="location_div">
                <Location />
                {t("riga")}
              </div>
              <div className="input_full">
                <input
                  type="text"
                  className="input_cta"
                  name="search"
                  id="search"
                  onChange={(e) => setQuery(e.target.value)}
                  value={query}
                  placeholder={t("search_for_restaurant_food_etc")}
                />

                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    const params = query
                      ? `?query=${encodeURIComponent(query)}`
                      : "";
                    navigate(`/all-restaurants${params}`);
                  }}
                >
                  <Search /> <span>{t("search")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="slider-container">
          <Swiper
            spaceBetween={20}
            slidesPerView={5}
            loop={true}
            autoplay={{ delay: 3000 }}
            navigation={true}
            pagination={{ clickable: true }}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              480: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1500: {
                slidesPerView: 6,
              },
            }}
          >
            {categories.map((benefit, index) => (
              <SwiperSlide key={index}>
                <div className={`slide-content`}>
                  <div className="bnft_img">
                    <img src={benefit.image} alt={benefit.name} />
                  </div>
                  <h3>{benefit.title}</h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className="res_hidden">
        <div className="res_custom_scroller">
          {categories.map((benefit, index) => (
            <div className={`slide-content`} key={index}>
              <div className="bnft_img">
                <img src={benefit.image} alt={benefit.name} />
              </div>
              <h3>{benefit.title}</h3>
            </div>
          ))}
        </div>
      </section>
      <div className="res_position_ordering">
        <section className="benifit_card_section">
          <div className="wrapper">
            <div className="benifit_grid">
              {benefits.map((benefit, index) => (
                <BenifitApp
                  key={index}
                  title={benefit.title}
                  description={benefit.description}
                  image={benefit.image}
                />
              ))}
            </div>
          </div>
        </section>
        <section className="restaurant_list_section">
          <div className="wrapper">
            <h2 className="subtitle_common">
              {t("food_delivery_restaurants_in")}{" "}
              <span className="text-primary">{t("riga")}</span>
            </h2>
            {/* <div>
              We will soon be available in your area. Please check back later.
            </div> */}
            <div className="item_list_grid">
              {listings.map((restaurant, index) => (
                <RestaurantListCard key={index} props={restaurant} />
              ))}
            </div>
            <Link to={"/all-restaurants"} className="btn btn-primary">
              {t("view_all")} <Rightarrow />
            </Link>
          </div>
        </section>
      </div>
      <CustomAd />
      <ClientTestimonial />
      <Pricing />
      <Faq faqs={faqs} faqimg={faqImage} />
      <Cta />
    </React.Fragment>
  );
};

export default Home;
